import gql from 'graphql-tag';

export const GET_INTERVIEW_LIST_PAGE_DATA = gql`
  query (
    $filter: ApplicationViewFilter
    $sort: ApplicationViewSort
    $paginator: PaginatorOptions
  ) {
    applicationViewsPaginated(
      filter: $filter
      sort: $sort
      paginator: $paginator
    ) {
      data {
        id
        applicationNo
        applicant {
          name {
            givenName
            surname
          }
        }
        programmeChoice {
          entryYear
          department
          programme
          programmeType
          studyMode
          researchArea
          proposedChiefSupervisor
          proposedChiefSupervisorBackup
          rejectedByFirstChoice
        }
        nomination {
          supervisors {
            type
            netId
            title
            givenName
            surname
          }
          fundings {
            schema
            source
          }
        }
        status
      }
    }
  }
`;
